import React, { useState, useContext } from "react";
import UserContext from "../context/UserContext";

const BASE_URL = process.env.REACT_APP_API_URL;

export default function Login() {
    const { setIsAuthenticated, setToken } = useContext(UserContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await fetch(BASE_URL + "/admin/login/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: username,
                    password: password,
                }),
            });

            const result = await response.json();
            if (response.ok && result.status === "OK" && result.token) {
                // Save the token in localStorage
                localStorage.setItem("token", result.token);
                setToken(result.token);
                setIsAuthenticated(true);
                console.log("Login successful");
            } else {
                setError(result.message || "Login failed");
            }
        } catch (error) {
            setError("An error occurred. Please try again later.");
            console.error("Login error:", error);
        }
    };

    return (
        <div className="loginContainer">
            <h1>Sisäänkirjautuminen</h1>
            {error && <p className="error">{error}</p>}
            <form className="loginForm" onSubmit={handleLogin}>
                <input
                    type="text"
                    placeholder="Käyttäjätunnus"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Salasana"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit">Kirjaudu</button>
            </form>
        </div>
    );
}
